import { SelectedDocumentType } from '../../utils/types/analytics'
import useCustomGlobalState from './useCustomGlobalState'

// Add new params when needed
// All available analytics params are listed in analytics documentation
export interface GlobalAnalyticsParams {
  categoryCode?: string
  resultQuantity?: number | string
  filterInteractionAmount?: number | string
  selectedFilterValue?: string
  selectedFilterCode?: string
  selectedDocument?: SelectedDocumentType
  totalActiveFilters?: number | string
}

type UseGlobalAnalyticsParamsResult = [
  GlobalAnalyticsParams,
  (newData: GlobalAnalyticsParams) => Promise<void>,
]

const useGlobalAnalyticsParams = (): UseGlobalAnalyticsParamsResult => {
  const [analyticsParams, setGlobalAnalyticsParams] = useCustomGlobalState('analyticsParams', {} as GlobalAnalyticsParams)

  return [analyticsParams, setGlobalAnalyticsParams]
}

export default useGlobalAnalyticsParams
